import { makeVar } from '@apollo/client';

export const shoppingCartShow = makeVar(false);

export const shoppingCartDialogVar = makeVar({});

export const shoppingCartOffersVar = makeVar([]);

export const offerSelectedClientsVar = makeVar({});
